/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddressVm
 */
export interface AddressVm {
    /**
     * 
     * @type {string}
     * @memberof AddressVm
     */
    country?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddressVm
     */
    county?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddressVm
     */
    zip?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddressVm
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddressVm
     */
    district?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddressVm
     */
    street?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddressVm
     */
    number?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddressVm
     */
    floor?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddressVm
     */
    door?: string | null;
}

export function AddressVmFromJSON(json: any): AddressVm {
    return AddressVmFromJSONTyped(json, false);
}

export function AddressVmFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddressVm {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'country': !exists(json, 'country') ? undefined : json['country'],
        'county': !exists(json, 'county') ? undefined : json['county'],
        'zip': !exists(json, 'zip') ? undefined : json['zip'],
        'city': !exists(json, 'city') ? undefined : json['city'],
        'district': !exists(json, 'district') ? undefined : json['district'],
        'street': !exists(json, 'street') ? undefined : json['street'],
        'number': !exists(json, 'number') ? undefined : json['number'],
        'floor': !exists(json, 'floor') ? undefined : json['floor'],
        'door': !exists(json, 'door') ? undefined : json['door'],
    };
}

export function AddressVmToJSON(value?: AddressVm | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'country': value.country,
        'county': value.county,
        'zip': value.zip,
        'city': value.city,
        'district': value.district,
        'street': value.street,
        'number': value.number,
        'floor': value.floor,
        'door': value.door,
    };
}


